module.exports = __webpack_public_path__ + "static/media/FazzNeue-BoldItalic.ddc33582.ttf";